<div class="modal-header">
  <h4 class="modal-title">Live Syslog Viewer Help</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h5>Controls</h5>
  <ul>
    <li><strong>Serial Number:</strong> Enter the device serial number to load logs for.</li>
    <li><strong>Lines:</strong> Select the number of log lines to retrieve.</li>
    <li><strong>Load Logs:</strong> Click to fetch and display the logs.</li>
    <li><strong>Word Wrap:</strong> Toggle whether long log lines wrap to the next line or require horizontal scrolling. Your preference is saved locally.</li>
  </ul>
  <h5>Actions</h5>
  <ul>
    <li><strong>Request New Log:</strong> This button sends a command to the device to generate and upload a new syslog file.</li>
  </ul>
  <h5>Log Viewer</h5>
  <p>The main area displays the log entries. Newest logs are shown at the bottom. The view will automatically scroll to the bottom when new logs are loaded.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>
